// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: Arial, Helvetica, sans-serif;
}
#editRoleTable {
    color: black;
    width: auto;
}
.myrow {
    display: flex;
    flex-wrap: wrap;
 }
.editRow {
    height:40px;
    width: 80%;
    margin: auto;
}
.mat-select{
    padding-left: 10px;
}
.no-style tr {
  background-color: transparent;
}
.no-style {
  border: none;
  width: 80%;
  margin: auto;
}

.no-style th,
.no-style td {
  border: none;
}

.no-style thead th,
.no-style thead td {
  border-bottom-width: 2px;
}

:host ::ng-deep .mat-form-field-infix {
  min-width: 300px
}

:host ::ng-deep .ql-editor {
  padding-top: 12px;
  min-height: 100px;
}

.custom-dropdown {
  position: relative;
  width: 200px;
  border: 1px solid #ccc;
  cursor: pointer;
}

.selected {
  padding: 10px;
  border-radius: 4px;
  color: #333;
  font-weight: bold;
}

.options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  background-color: white;
  z-index: 10;
  border-radius: 4px;
  max-height: 200px; /* Set a max-height for scrolling */
  overflow-y: auto; /* Enable scrolling if options exceed max-height */
}

.option {
  padding: 10px;
  cursor: pointer;
  width: 100%; /* Ensure the option stretches across the entire width */
  transition: background-color 0.3s;
}

.option:hover {
  background-color: #f0f0f0; /* Hover effect */
}

.error-border {
  border: 2px solid red;
}



`, "",{"version":3,"sources":["webpack://./src/app/role-detail-edit/role-detail-edit.component.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,eAAe;CAClB;AACD;IACI,WAAW;IACX,UAAU;IACV,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,iBAAiB,EAAE,mCAAmC;EACtD,gBAAgB,EAAE,kDAAkD;AACtE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW,EAAE,wDAAwD;EACrE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["* {\n    font-family: Arial, Helvetica, sans-serif;\n}\n#editRoleTable {\n    color: black;\n    width: auto;\n}\n.myrow {\n    display: flex;\n    flex-wrap: wrap;\n }\n.editRow {\n    height:40px;\n    width: 80%;\n    margin: auto;\n}\n.mat-select{\n    padding-left: 10px;\n}\n.no-style tr {\n  background-color: transparent;\n}\n.no-style {\n  border: none;\n  width: 80%;\n  margin: auto;\n}\n\n.no-style th,\n.no-style td {\n  border: none;\n}\n\n.no-style thead th,\n.no-style thead td {\n  border-bottom-width: 2px;\n}\n\n:host ::ng-deep .mat-form-field-infix {\n  min-width: 300px\n}\n\n:host ::ng-deep .ql-editor {\n  padding-top: 12px;\n  min-height: 100px;\n}\n\n.custom-dropdown {\n  position: relative;\n  width: 200px;\n  border: 1px solid #ccc;\n  cursor: pointer;\n}\n\n.selected {\n  padding: 10px;\n  border-radius: 4px;\n  color: #333;\n  font-weight: bold;\n}\n\n.options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  border: 1px solid #ccc;\n  background-color: white;\n  z-index: 10;\n  border-radius: 4px;\n  max-height: 200px; /* Set a max-height for scrolling */\n  overflow-y: auto; /* Enable scrolling if options exceed max-height */\n}\n\n.option {\n  padding: 10px;\n  cursor: pointer;\n  width: 100%; /* Ensure the option stretches across the entire width */\n  transition: background-color 0.3s;\n}\n\n.option:hover {\n  background-color: #f0f0f0; /* Hover effect */\n}\n\n.error-border {\n  border: 2px solid red;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
